import type { IFCMNotificationPayload } from 'BreetHelpers';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';

const firebaseConfig = {
	apiKey: 'AIzaSyD3QSCTmCUqf31PSFY1esCDEncG1BtIdzg',
	authDomain: 'breet-app-979ad.firebaseapp.com',
	projectId: 'breet-app-979ad',
	storageBucket: 'breet-app-979ad.firebasestorage.app',
	messagingSenderId: '426070545367',
	appId: '1:426070545367:web:b718a6362944c52d003192',
	databaseURL: 'https://breet-app-979ad-default-rtdb.firebaseio.com',
	measurementId: 'G-F2DQBS0GBV',
	vapidKey: 'BPlP9kGxRlKJE8Fx9yd8XpRw-eLKT1mnKMqDo6vMR2aQvVGe_ysAP1E4971X2XPbA7N5eHwioA_O6oOhU2cGVGA',
};

const app = initializeApp(firebaseConfig);
export const getMessagingInstance = async () => {
	const isMessagingSupported = await isSupported();
	return isMessagingSupported ? getMessaging(app) : null;
};

type WebTokenCallback = (currentToken: string | null) => void;

export const getWebToken = async ({ callback }: { callback?: WebTokenCallback } = {}): Promise<string | null> => {
	try {
		const messaging = await getMessagingInstance();
		if (!messaging) return null;

		if (Notification.permission !== 'granted') {
			const permission = await Notification.requestPermission();
			if (permission !== 'granted') return null;
		}

		if (!('serviceWorker' in navigator)) return null;

		const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

		await navigator.serviceWorker.ready;

		const currentToken = await getToken(messaging, {
			vapidKey: firebaseConfig.vapidKey,
			serviceWorkerRegistration: registration,
		});

		if (currentToken && callback) callback(currentToken);
		return currentToken;
	} catch (err) {
		console.error('FCM Token Error:', err);
		return null;
	}
};

export const onMessageListener = async (callback: (payload: IFCMNotificationPayload) => void) => {
	const messaging = await getMessagingInstance();
	if (!messaging) return null;

	return onMessage(messaging, (payload) => {
		callback(payload as IFCMNotificationPayload);
	});
};
